import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type INotificationsState from './interfaces/INotificationsState';

export const initialState: INotificationsState = {
  modalNotifications: false,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setModalNotifications: (state, { payload }: PayloadAction<boolean>) => {
      state.modalNotifications = payload;
    },
    resetState: () => initialState,
  },
});

export const { setModalNotifications, resetState } = notificationsSlice.actions;

export default notificationsSlice.reducer;
